// extracted by mini-css-extract-plugin
export default {"root":"Price-root_nEvfS","priceCrossedOut":"Price-priceCrossedOut_kfjPD","price":"Price-price_oFYYT"};